import { EntityService } from './EntityService';
import { ICustomField } from '../types';
import axios from 'axios';

export class CustomFieldService extends EntityService<ICustomField> {
    constructor() {
        super(`/CustomFields`);
    }

    public update(entityId: number, entity: Partial<ICustomField>): Promise<void> {
        const entityToPost = entity;
        delete entityToPost.CustomFieldDfn;
        return this.axiosPatch(`${this.entityUrl}(${entityId})`, entityToPost); 
    }

    public static customFieldsToBadgeStrings = (customFields: ICustomField[]): string[] => {
        return customFields?.filter(a => a.CustomFieldDfn?.Display).map(a => a.CustomFieldDfn?.Title ?? '');
      };
      
}